module.exports = __webpack_public_path__ + "img/1440.bc9188b9.jpg";